/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { Button } from "antd";
import styled, { css } from "styled-components";
import color from "../_style/color";
import WithSpacing from "../hoc/withSpacing";

const buttonType = {
  sunsetOrange: css`
    background: ${color.sunsetOrange};
    border-color: ${color.sunsetOrange};
    color: ${color.light};
    :hover,
    :focus,
    :active {
      background: ${color.sunsetOrange};
      border-color: ${color.sunsetOrange};
    }
  `,
  highempahis: css`
    background: ${color.highempahis};
    border-color: ${color.highempahis};
    color: ${color.light};
    :hover,
    :focus,
    :active {
      background: ${color.highempahis};
      border-color: ${color.highempahis};
    }
  `,
  defaultHoverable: css`
    background: ${color.light};
    border-color: ${color.gainsboro};
    color: ${color.primary};
    :hover,
    :focus,
    :active {
      color: ${color.light};
      background: ${color.primary};
      border-color: ${color.primary};
    }
  `,
  default: css`
    background: ${color.light};
    border-color: ${color.gainsboro};
    :hover,
    :focus,
    :active {
      background: ${color.light};
      border-color: ${color.gainsboro};
    }
  `,
  primary: css`
    background: ${color.primary};
    border-color: ${color.primary};
    :hover,
    :focus,
    :active {
      color: ${color.primary};
      background: ${color.primary};
      border-color: ${color.primary};
    }
  `,
  widget: css`
    background: ${color.light};
    border: none;
    border-bottom: 1px solid ${color.gainsboro};
    :hover,
    :focus {
      border-color: ${color.gainsboro};
      color: ${color.highempahis};
    }

    ${({ active }) =>
      active &&
      css`
        ,
        :hover {
          background: ${color.aliceBlue};
          color: ${color.primary};
        }
      `};
  `,
};

const ButtonCustom = React.memo(
  styled(Button)
    .withConfig({
      shouldForwardProp: (prop) => !["round", "active", "borderLess"].includes(prop),
    })
    .attrs((props) => ({
      height: props.height || "auto",
      type: props.type || "default",
      round: props.round,
      active: props.active,
      borderLess: props.borderLess,
      margin: props.margin || "0 !important",
      padding: props.padding || "4px 15px",
    }))`
    border-radius: ${({ round }) => (round ? "2px" : "0px")};
    height: ${({ height }) => height};
    margin: ${({ margin }) => margin};
    padding: ${({ padding }) => padding};
    
    ::after{
      content: unset;
    }
    
    ${({ type }) => buttonType[type]};
    border : ${({ borderLess }) => borderLess && "none"};
`,
);

const HumbergerButtonComp = styled.div
  .withConfig({ shouldForwardProp: (props) => !["active"].includes(props) })
  .attrs((props) => ({
    active: props.active,
  }))`
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 10px;
  
  span {
    display: block;
    height: 1px;
    width: 16px;
    background: ${color.dimgray};
    margin: 4px auto 0;
    transition : 0.3s;
  }
  
  ${({ active }) =>
    active &&
    css`
      background: ${color.light};
      border-left: 1px solid ${color.gainsboro};
      position: relative;
      ::after {
        content: "";
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 2px;
        background: ${color.light};
      }
      span:nth-child(1) {
        transform: rotate(45deg);
        position: relative;
        top: 5px;
      }
      span:nth-child(2) {
        display: none;
      }
      span:nth-child(3) {
        transform: rotate(-45deg);
        position: relative;
        bottom: 0;
      }
    `}
`;

const HumbergerButton = ({ className, ...otherProps }) => (
  <HumbergerButtonComp className={className} {...otherProps}>
    <span />
    <span />
    <span />
  </HumbergerButtonComp>
);
export { HumbergerButton };

export default WithSpacing(ButtonCustom);
